export const escapeRegExp = (value: string) => value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")

export const getShortDescription = (text: string | undefined) => {
    if (text && text.length > 100) {
        return text.substring(0, 97) + "..."
    } else {
        return text
    }
}

const INVISIBLE_CHARACTERS = /[\u00AD\u200B-\u200F\u202A-\u202E\u2060-\u2064\u2066-\u206F\uFEFF]/g

export const sanitizeSearchQuery = (value: string) =>
    value.replace(INVISIBLE_CHARACTERS, "").replace(/\s+/g, " ").trim()

// export-to-csv wraps values in quotes but does not double the quotes inside them.
export const toCsvText = (value: string) => value.replaceAll('"', '""')

export const toInitials = (parts: ReadonlyArray<string | undefined>) =>
    parts
        .map((part) => part?.trim().charAt(0) ?? "")
        .join("")
        .toUpperCase()

export const toDisplayNameInitials = (displayName: string | undefined) => {
    const words = displayName?.trim().split(/\s+/) ?? []
    return toInitials(words.length > 1 ? [words[0], words[words.length - 1]] : words)
}
